import { Base } from '@studiometa/js-toolkit';

/**
 *  Ajax form component
 */
export default class AjaxForm extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'AjaxForm',
    refs: ['message', 'input[]', 'submitBtn'],
  };

  /**
   * Switch tab on button click.
   * @param  {Event}  event The click event object.
   * @returns {void}
   */
  async onSubmit(event) {
    event.preventDefault();
    this.$refs.message.innerHTML = '';
    this.$refs.submitBtn.disabled = true;

    const formData = new FormData(event.target);
    const givenData = {};
    formData.forEach((value, key) => {
      givenData[key] = value;
    });

    const data = await fetch(event.target.action, {
      method: event.target.method,
      body: JSON.stringify(givenData),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    });

    if (data.success) {
      this.$refs.input.forEach((input) => {
        input.value = '';
      });
    }
    this.$refs.submitBtn.disabled = false;

    this.$refs.message.innerHTML = data.message;
  }
}
